import { Controller } from "@hotwired/stimulus"
import { subscribeToBot } from "../channels/bot_subscription"

// Renders the bot's positions as table rows and keeps them live via
// BotChannel. A bot has few positions, so the whole table is re-rendered.
export default class extends Controller {
  static targets = ["tbody", "status"]
  static values = { botId: Number }

  connect() {
    this.load()
    this.subscription = subscribeToBot({
      botId: this.botIdValue,
      onUpdate: (data) => {
        if (data.positions) this.render(data.positions)
      }
    })
  }

  disconnect() {
    if (this.subscription) this.subscription.unsubscribe()
  }

  async load() {
    try {
      const response = await fetch(`/bots/${this.botIdValue}/positions.json`)
      if (!response.ok) throw new Error(`positions request failed: ${response.status}`)
      const data = await response.json()
      this.render(data.positions || [])
    } catch (error) {
      console.warn("positions-table: failed to load positions", error)
      this.statusTarget.textContent = "failed to load positions"
    }
  }

  render(positions) {
    this.tbodyTarget.replaceChildren(...positions.map((p) => this.buildRow(p)))
    this.statusTarget.textContent = positions.length
      ? `${positions.length} position${positions.length === 1 ? "" : "s"}`
      : "no positions yet"
  }

  buildRow(position) {
    const tr = document.createElement("tr")
    tr.className = "border-t border-[var(--color-line-soft)] hover:bg-[var(--color-elev-2)]"

    const num = (value) =>
      value === null || value === undefined
        ? "—"
        : Number(value).toLocaleString(undefined, { maximumFractionDigits: 8 })
    const stamp = (iso) => (iso ? iso.replace("T", " ").slice(0, 16) : "—")
    const pnl = position.pnl
    const pnlClass =
      pnl == null ? "" : pnl >= 0 ? "text-[var(--color-accent)]" : "text-[var(--color-danger)]"
    const statusChip = position.status === "open" ? "chip-warn" : "chip-ok"

    tr.innerHTML = `
      <td class="px-4 py-2"><span class="chip ${statusChip}">${position.status}</span></td>
      <td class="px-4 py-2 text-right">${num(position.entry_price)}</td>
      <td class="px-4 py-2 text-right">${num(position.exit_price)}</td>
      <td class="px-4 py-2 text-right">${num(position.quantity)}</td>
      <td class="px-4 py-2 text-right ${pnlClass}">${num(position.pnl)}</td>
      <td class="px-4 py-2 text-right ${pnlClass}">${
        position.pnl_pct == null ? "—" : `${position.pnl_pct}%`
      }</td>
      <td class="px-4 py-2 text-[var(--color-fg-muted)]">${stamp(position.opened_at)}</td>
      <td class="px-4 py-2 text-[var(--color-fg-muted)]">${stamp(position.closed_at)}</td>
    `
    return tr
  }
}
